<h3>Dokumente</h3>
<p>Mitgesendete Dokumente werden automatisch im Kundenportal zur Verfügung gestellt.</p>
<p>Bitte senden Sie nur Dokumente mit, die für die Finanzierung von Relevanz sein können,
wie z.B. Exposé, Fotos der Immobilie, Grundbuchauszug, Grundriss, Baubeschreibung, Energieausweis, Lageplan / Flurkarte, etc.</p>

